import { Reducer, Action } from "redux";
import {
    ILoggedInUserState,
    KnownAction,
    SUBMIT_LOGIN,
    SET_BUSINESS_NAME,
    SECURE_CODE,
    SUBMIT_COMMUNICATION_METHOD,
    SET_USER_FIRSTNAME_AND_LASTNAME,
    SELECT_COMMUNICATION_METHOD,
    GET_USER_SERVICES,
    GET_ACTIVE_ACCOUNT,
    GET_FAMILY_MEMBERS,
    TERMS_AND_CONDITION_REACCEPTANCE,
    SET_CHILD_SUBCUSTOMER_ID,
    SET_HAS_IDF_FAMILY_SERVICE,
    SET_FAMILY_MEMBER_LOADER,
    SET_CHILD_DOB,
    SET_IS_TU_USER,
    SET_PREFERENCED_LANGUAGE,
    SET_LANGUAGE_CHANGE,
    SET_USER_PHONE,
    SET_HAS_CCAM,
    SET_SUCCESSFUL_ENROLLED_CHILD_LIST,
    SET_FAILED_ENROLLED_CHILD_LIST,
    SET_MONITORED_CHILD_COUNT,
    RECEIVE_CATALOG_PRODUCTS,
    GET_AGE_LIMIT,
    GET_ACTIVE_PACKAGE_ENROLLMENT,
} from "./types";

export const reducer: Reducer<ILoggedInUserState> = (state: ILoggedInUserState | undefined, incomingAction: Action): ILoggedInUserState => {
    if (state === undefined) {
        return {
            userInfo: {},
            activeAccount: {},
            isLoadingFamilyMember: false,
            isLoadedActiveUserServices: false,
            catalogProducts: [],
            oneTimeProducts: [],
            hasPurchaseCreditReport: false,
        };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SUBMIT_LOGIN:
            return {
                ...state,
                userInfo: action.userInfo,
                activeAccount: {
                    accountType: "PRIMARY",
                    firstName: action.userInfo.firstName,
                    lastName: action.userInfo.lastName,
                    email: action.userInfo.EmailAddress,
                    subcustomerId: "PRIMARY",
                },
            };
        case GET_ACTIVE_ACCOUNT:
            return {
                ...state,
                activeAccount: action.activeAccount,
            };
        case SET_USER_FIRSTNAME_AND_LASTNAME:
            return {
                ...state,
                activeAccount: {
                    ...state.activeAccount,
                    firstName: action.userInformation.firstName,
                    lastName: action.userInformation.lastName,
                },
            };
        case SET_HAS_IDF_FAMILY_SERVICE:
            return {
                ...state,
                hasFamilyService: action.hasFamilyService,
            };
        case SET_CHILD_SUBCUSTOMER_ID:
            return {
                ...state,
                childSubcustomerIdToCompleteAccount: action.childSubcustomerIdToCompleteAccount,
            };
        case TERMS_AND_CONDITION_REACCEPTANCE:
            return {
                ...state,
                termsAndConditionsReacceptance: action.termsAndConditionsReacceptance,
            };
        case SECURE_CODE:
            return {
                ...state,
                secureCode: action.secureCode,
            };
        case GET_FAMILY_MEMBERS:
            return {
                ...state,
                familyMembers: action.familyMembers,
            };
        case SELECT_COMMUNICATION_METHOD:
            return {
                ...state,
                selectedMethod: action.selectedMethod,
            };
        case GET_USER_SERVICES:
            return {
                ...state,
                isLoadedActiveUserServices: true,
                userServiceDetails: action.userServiceDetails,
            };
        case SUBMIT_COMMUNICATION_METHOD:
            return {
                ...state,
                communicationMethodList: action.communicationMethodList,
            };
        case SET_BUSINESS_NAME:
            return {
                ...state,
                businessName: action.businessName,
            };
        case SET_FAMILY_MEMBER_LOADER:
            return {
                ...state,
                isLoadingFamilyMember: action.isLoadingFamilyMember,
            };
        case SET_CHILD_DOB:
            return {
                ...state,
                childDOBToCompleteAccount: action.childDOBToCompleteAccount,
            };
        case SET_IS_TU_USER:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    isTUUser: action.isTuUser,
                },
            };
        case SET_PREFERENCED_LANGUAGE:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    preferencedLanguage: action.preferencedLanguage,
                    
                },
            };


        case SET_LANGUAGE_CHANGE:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                  
                    hasLanguageChanged: action.hasLanguageChanged
                },
            };
        case SET_USER_PHONE:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    phoneNumber: action.phoneNumber,
                },
            };
        case SET_HAS_CCAM:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    hasCCAM: action.hasCCAM,
                },
            };
        case SET_SUCCESSFUL_ENROLLED_CHILD_LIST:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    childrenList: action.childrenList,
                },
            };
        case SET_FAILED_ENROLLED_CHILD_LIST:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    failedChildrenList: action.failedChildrenList,
                },
            };
        case SET_MONITORED_CHILD_COUNT:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    numChildrenMonitored: action.numChildrenMonitored,
                },
            };
        case RECEIVE_CATALOG_PRODUCTS:
            return {
                ...state,
                catalogProducts: action.catalogProducts,
                oneTimeProducts: action.oneTimeProducts,
                hasPurchaseCreditReport: action.hasPurchaseCreditReport,
            };
        case GET_AGE_LIMIT:
            return {
                ...state,
                ageLimit: action.ageLimit,
            };
        case GET_ACTIVE_PACKAGE_ENROLLMENT:
            return {
                ...state,
                activePackageInfo: action.activePackage,
            };
            
        default:
            return state;
    }
};
